import axios from "axios";
import _ from "lodash";
import moment from "moment-timezone";
import { t } from "i18next";

import AlertsService from "services/alerts-service";

import { mergeStorage, omitStorage } from "hooks/useStorage";

const BookingsApi = {
    getMyBookings: async () => {
        try {
            const { data: response } = (await axios.get(`/bookings/my`)) as any;
            mergeStorage(`bookings`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t('qmcweglrn3k'));
        }
    },
    createBooking: async (booking: any) => {
        try {
            const { data: response } = (await axios.post(`/bookings`, {
                ...booking,
                dates: {
                    from: moment(booking?.dates?.from).format(`YYYY-MM-DD`),
                    to: moment(booking?.dates?.to).format(`YYYY-MM-DD`),
                },
            })) as any;
            await BookingsApi.getMyBookings();
            AlertsService.showSuccess(`Бронирование успешно создано`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t('ritvv591jne'));
        }
    },
    updateBooking: async (booking: { id: string; [key: string]: any }) => {
        try {
            const { data: response } = (await axios.put(`/bookings`, {
                ...booking,
                dates: {
                    from: moment(booking?.dates?.from).format(`YYYY-MM-DD`),
                    to: moment(booking?.dates?.to).format(`YYYY-MM-DD`),
                },
            })) as any;
            await BookingsApi.getMyBookings();
            AlertsService.showSuccess(`Бронирование успешно обновлено`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t('d8lah0t0r1'));
        }
    },
    updateEventBooking: async (booking: { id: string; [key: string]: any }) => {
        try {
            const { data: response } = (await axios.put(`/event-bookings`, {
                ...booking,
                dates: {
                    from: moment(booking?.dates?.from).format(`YYYY-MM-DD`),
                    to: moment(booking?.dates?.to).format(`YYYY-MM-DD`),
                },
            })) as any;
            await BookingsApi.getMyBookings();
            AlertsService.showSuccess(`Бронирование успешно обновлено`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t('d8lah0t0r1'));
        }
    },
    deleteBooking: async (bookingId: string) => {
        try {
            await axios.delete(`/bookings/${bookingId}`);
            omitStorage(`bookings.${bookingId}`);
            AlertsService.showSuccess(`Бронирование успешно удалено`);
            return;
        } catch (error) {
            throw AlertsService.showError(t('x62xijklp0e'));
        }
    },
};

export default BookingsApi;
